import React, { useState, useEffect } from 'react';
import { auth, googleProvider } from '../App';
import { signInWithEmailAndPassword, createUserWithEmailAndPassword, signInWithPopup } from 'firebase/auth';

const LoginScreen = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [turnstileToken, setTurnstileToken] = useState('');
    const [turnstileLoaded, setTurnstileLoaded] = useState(false);

    useEffect(() => {
        // Check if Turnstile is loaded
        const checkTurnstile = () => {
            if (window.turnstile) {
                setTurnstileLoaded(true);
                // Render the widget
                window.turnstile.render('.cf-turnstile', {
                    sitekey: '0x4AAAAAABiySfkur5_heHCp',
                    callback: handleTurnstileCallback,
                    'expired-callback': handleTurnstileExpired,
                });
            } else {
                // Retry after a short delay
                setTimeout(checkTurnstile, 100);
            }
        };
        
        checkTurnstile();
    }, []);

    const handleEmailPasswordSubmit = async (e) => {
        e.preventDefault();
        setError('');
        if (!email || !password) { setError("Please enter both email and password."); return; }
        if (!turnstileLoaded) { setError("Security check is loading. Please wait."); return; }
        if (!turnstileToken) { setError("Please complete the security check."); return; }
        try {
            await signInWithEmailAndPassword(auth, email, password);
        } catch (signInError) {
            if (signInError.code === 'auth/user-not-found' || signInError.code === 'auth/invalid-credential') {
                try {
                    await createUserWithEmailAndPassword(auth, email, password);
                } catch (signUpError) { setError(signUpError.message); }
            } else { setError(signInError.message); }
        }
    };

    const handleGoogleSignIn = async () => {
        setError('');
        if (!turnstileLoaded) { setError("Security check is loading. Please wait."); return; }
        if (!turnstileToken) { setError("Please complete the security check."); return; }
        try { await signInWithPopup(auth, googleProvider); } 
        catch (e) { setError(e.message); }
    };

    const handleTurnstileCallback = (token) => {
        setTurnstileToken(token);
        setError('');
    };

    const handleTurnstileExpired = () => {
        setTurnstileToken('');
        setError('Security check expired. Please try again.');
    };
    
    return (
        <div className="min-h-screen flex items-center justify-center p-4">
            <div className="login-container relative z-10 w-full max-w-md p-8 space-y-6 rounded-2xl">
                <div>
                    <div className="flex items-center justify-center mb-4">
                        <img src="/logo.svg" alt="misecure logo" className="h-12 w-12 mr-3" />
                        <h1 className="text-center text-3xl font-bold tracking-widest text-white">mi<span className="text-sky-400">secure</span>.my</h1>
                    </div>
                    <p className="mt-2 text-center text-sm text-gray-400">Secure Access Portal</p>
                </div>
                {error && <p className="text-center text-sm text-red-400 p-2 bg-red-900/50 rounded">{error}</p>}
                <form className="space-y-6" onSubmit={handleEmailPasswordSubmit}>
                    <div className="rounded-md shadow-sm -space-y-px">
                        <input value={email} onChange={e => setEmail(e.target.value)} id="email-address" name="email" type="email" required className="form-input text-white appearance-none rounded-none relative block w-full px-3 py-3 placeholder-gray-500 focus:outline-none focus:z-10 sm:text-sm rounded-t-md" placeholder="Email address" />
                        <input value={password} onChange={e => setPassword(e.target.value)} id="password" name="password" type="password" required className="form-input text-white appearance-none rounded-none relative block w-full px-3 py-3 placeholder-gray-500 focus:outline-none focus:z-10 sm:text-sm rounded-b-md" placeholder="Password" />
                    </div>
                    <div className="flex justify-center">
                        <div className="cf-turnstile"></div>
                        {!turnstileLoaded && (
                            <div className="text-center text-gray-400 text-sm">
                                Loading security check...
                            </div>
                        )}
                    </div>
                    <button type="submit" className="login-button w-full flex justify-center py-3 px-4 text-sm font-bold rounded-md text-white">Sign In / Register</button>
                </form>
                <div className="relative flex py-2 items-center"><div className="flex-grow border-t border-gray-600"></div><span className="flex-shrink mx-4 text-gray-400 text-xs">OR</span><div className="flex-grow border-t border-gray-600"></div></div>
                <button type="button" onClick={handleGoogleSignIn} className="google-button w-full flex justify-center items-center py-3 px-4 text-sm font-medium rounded-md text-white">
                    <svg className="w-5 h-5 mr-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 488 512"><path fill="currentColor" d="M488 261.8C488 403.3 381.5 512 244 512 109.8 512 0 402.2 0 261.8S109.8 11.8 244 11.8c70.3 0 129.8 28.7 174.3 72.9l-67.8 67.8C314.6 114.5 282.5 98.2 244 98.2c-73.8 0-133.8 60-133.8 133.8s60 133.8 133.8 133.8c79.9 0 119.5-56.2 124.7-89.9H244v-87.5h243.9c1.3 7.8 2.1 15.9 2.1 24.1z"></path></svg>
                    Sign in with Google
                </button>
            </div>
        </div>
    );
};

export default LoginScreen;
